import $http from '../../utils/http';

const requestTest = params => {
  // console.log(params)
  return $http({
    url: 'hello/test',
    params
  });
};
const requestTodo = params => {
  // console.log(params)
  return $http({
    url: 'hello/demo',
    params
  });
};

export default {
  requestTest,
  requestTodo
};
